import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = {
  key: 2
};
var _hoisted_3 = {
  key: 3
};
var _hoisted_4 = {
  key: 5
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  key: 2,
  class: "image-container-hover"
};
var _hoisted_7 = {
  class: "image-container-hover-text"
};
import TUIChatEngine, { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { ref, watchEffect } from '../../../../adapter-vue';
import MessageAbstractText from './message-abstract/message-abstract-text.vue';
import MessageAbstractFile from './message-abstract/message-abstract-file.vue';
import MessageAbstractCustom from './message-abstract/message-abstract-custom.vue';
import MessageAbstractImage from './message-abstract/message-abstract-image.vue';
import MessageAbstractVideo from './message-abstract/message-abstract-video.vue';
import { generateSearchResultShowName, generateSearchResultAvatar, generateSearchResultShowContent, generateSearchResultTime, enterConversation } from '../../utils';
import { messageTypeAbstractMap } from '../../type';
import { isPC } from '../../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    listItem: {
      default: () => ({})
    },
    listItemContent: {
      default: () => ({})
    },
    type: {
      default: 'allMessage'
    },
    displayType: {
      default: 'info'
    },
    keywordList: {
      default: () => []
    }
  },
  emits: ['showResultDetail', 'navigateToChatPosition'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var TYPES = ref(TUIChatEngine.TYPES);
    var avatarForShow = ref('');
    var nameForShow = ref('');
    var contentForShow = ref([]);
    var timeForShow = ref('');
    var isHovering = ref(false);
    watchEffect(() => {
      var _props$listItem, _props$listItem2;
      avatarForShow.value = generateSearchResultAvatar(props.listItem);
      nameForShow.value = generateSearchResultShowName(props.listItem, props === null || props === void 0 ? void 0 : props.listItemContent);
      contentForShow.value = generateSearchResultShowContent(props.listItem, props.type, props.keywordList, (props === null || props === void 0 ? void 0 : props.displayType) !== 'bubble');
      timeForShow.value = (_props$listItem = props.listItem) !== null && _props$listItem !== void 0 && _props$listItem.time ? generateSearchResultTime(((_props$listItem2 = props.listItem) === null || _props$listItem2 === void 0 ? void 0 : _props$listItem2.time) * 1000) : '';
    });
    var onResultItemClicked = () => {
      if (props.type === 'contact' || props.type === 'group') {
        enterConversation(props.listItem);
      } else {
        var _props$listItem3;
        if (props.displayType === 'info' && !((_props$listItem3 = props.listItem) !== null && _props$listItem3 !== void 0 && _props$listItem3.ID)) {
          emits('showResultDetail', true, props.type, props.listItem);
        } else {
          navigateToChatPosition();
        }
      }
    };
    var setHoverStatus = status => {
      isHovering.value = status;
    };
    var navigateToChatPosition = () => {
      // 定位到指定位置
      emits('navigateToChatPosition', props.listItem);
    };
    var getMessageAbstractType = message => {
      return message !== null && message !== void 0 && message.type ? TUITranslateService.t("TUISearch.".concat(messageTypeAbstractMap[message.type])) : '';
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['search-result-list-item', !_unref(isPC) && 'search-result-list-item-h5', 'search-result-list-item-' + _ctx.displayType, _unref(isHovering) && 'hover-' + _ctx.displayType]),
        onClick: onResultItemClicked,
        onMouseenter: _cache[0] || (_cache[0] = $event => setHoverStatus(true)),
        onMouseleave: _cache[1] || (_cache[1] = $event => setHoverStatus(false))
      }, [_ctx.displayType === 'info' || _ctx.displayType === 'bubble' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.displayType])
      }, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.displayType + '-left')
      }, [_createElementVNode("img", {
        class: _normalizeClass(_ctx.displayType + '-left-avatar'),
        src: _unref(avatarForShow) || '',
        onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
      }, null, 10, _hoisted_1)], 2), _createElementVNode("div", {
        class: _normalizeClass([_ctx.displayType + '-main'])
      }, [_createElementVNode("div", {
        class: _normalizeClass([_ctx.displayType + '-main-name'])
      }, _toDisplayString(_unref(nameForShow)), 3), _createElementVNode("div", {
        class: _normalizeClass([_ctx.displayType + '-main-content'])
      }, [_ctx.displayType === 'info' || _ctx.listItem.type === _unref(TYPES).MSG_TEXT ? (_openBlock(), _createBlock(MessageAbstractText, {
        key: 0,
        content: _unref(contentForShow),
        highlightType: _ctx.displayType === 'info' ? 'font' : 'background',
        displayType: _ctx.displayType
      }, null, 8, ["content", "highlightType", "displayType"])) : _ctx.listItem.type === _unref(TYPES).MSG_FILE ? (_openBlock(), _createBlock(MessageAbstractFile, {
        key: 1,
        contentText: _unref(contentForShow),
        messageContent: _ctx.listItemContent,
        displayType: _ctx.displayType
      }, null, 8, ["contentText", "messageContent", "displayType"])) : _ctx.listItem.type === _unref(TYPES).MSG_IMAGE ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _ctx.listItem.type === _unref(TYPES).MSG_VIDEO ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _ctx.listItem.type === _unref(TYPES).MSG_CUSTOM ? (_openBlock(), _createBlock(MessageAbstractCustom, {
        key: 4,
        contentText: _unref(contentForShow),
        message: _ctx.listItem,
        messageContent: _ctx.listItemContent
      }, null, 8, ["contentText", "message", "messageContent"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(getMessageAbstractType(_ctx.listItem)), 1))], 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(_ctx.displayType + '-right')
      }, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.displayType + '-right-time')
      }, _toDisplayString(_unref(timeForShow)), 3), _ctx.displayType === 'bubble' && _unref(isHovering) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.displayType + '-right-to'),
        onClick: _withModifiers(navigateToChatPosition, ["stop"])
      }, _toDisplayString(_unref(TUITranslateService).t("TUISearch.定位到聊天位置")), 3)) : _createCommentVNode("", true)], 2)], 2)) : _ctx.displayType === 'file' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([_ctx.displayType])
      }, [_createElementVNode("div", {
        class: _normalizeClass([_ctx.displayType + '-header'])
      }, [_createElementVNode("img", {
        class: _normalizeClass(_ctx.displayType + '-header-avatar'),
        src: _unref(avatarForShow),
        onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
      }, null, 10, _hoisted_5), _createElementVNode("div", {
        class: _normalizeClass([_ctx.displayType + '-header-name'])
      }, _toDisplayString(_unref(nameForShow)), 3), _unref(isHovering) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.displayType + '-header-to'),
        onClick: _withModifiers(navigateToChatPosition, ["stop"])
      }, _toDisplayString(_unref(TUITranslateService).t("TUISearch.定位到聊天位置")), 3)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(_ctx.displayType + '-header-time')
      }, _toDisplayString(_unref(timeForShow)), 3)], 2), _createElementVNode("div", {
        class: _normalizeClass([_ctx.displayType + '-main-content'])
      }, [_createVNode(MessageAbstractFile, {
        contentText: _unref(contentForShow),
        messageContent: _ctx.listItemContent,
        displayType: "bubble"
      }, null, 8, ["contentText", "messageContent"])], 2)], 2)) : _ctx.displayType === 'image' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass([_ctx.displayType])
      }, [_createElementVNode("div", {
        class: "image-container",
        onClick: _withModifiers(navigateToChatPosition, ["stop"])
      }, [_ctx.listItem.type === _unref(TYPES).MSG_IMAGE ? (_openBlock(), _createBlock(MessageAbstractImage, {
        key: 0,
        messageContent: _ctx.listItemContent
      }, null, 8, ["messageContent"])) : _ctx.listItem.type === _unref(TYPES).MSG_VIDEO ? (_openBlock(), _createBlock(MessageAbstractVideo, {
        key: 1,
        messageContent: _ctx.listItemContent
      }, null, 8, ["messageContent"])) : _createCommentVNode("", true), _unref(isHovering) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(TUITranslateService).t("TUISearch.定位到聊天位置")), 1)])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true)], 34);
    };
  }
});